import * as React from 'react';
import * as moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { getSelectedTeamAccount } from '../../../../../selectors/uiSelector';
import { Text, TextStyle, Inset, InlineChildren, InsetSize, } from '@doordash/design-language';
import { TrackOrderButton, EntryContainer, EntryTileButtonsWrapper, EstimatedDeliveryTimeText, HiddenPlaceholderForEmptyText, } from './GroupOrderEntryStyles';
import { CalendarStrings } from '../Calendar/CalendarStrings';
import { EXTERNAL_ROUTES } from '../../../../../constants/values';
import { shouldUseMobileViewForEntryTile } from './EntryViewHelper';
import { useContainerDimensions } from '../../../../../utils/useContainerDimensions';
import StoreImageView from './StoreImageView';
import track from '../../../../../utils/track';
import { EmployeeCalendarEvents } from '../../../../../constants/events';
import { useCalendarViewContext } from '../Calendar/CalendarViewContext';
import { GroupOrderEntryTestId } from '../../../../../core/Common/testId';
import { checkEntrySize } from '../../utils/checkEntrySize';
var contentStrings = CalendarStrings.groupOrderEntry.trackOrder;
var EntryViewTrackOrder = function (_a) {
    var entry = _a.entry, _b = _a.debugMode, debugMode = _b === void 0 ? false : _b;
    var entryRef = React.useRef(null);
    var dimensions = useContainerDimensions(entryRef);
    var isMobile = shouldUseMobileViewForEntryTile(dimensions);
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var _c = useCalendarViewContext(), isEmployeeView = _c.isEmployeeView, calendarInfo = _c.calendarInfo;
    var entryDate = moment(entry.checkoutTime).format('YYYY-MM-DD');
    var formattedDeliveryTime = moment(entry.targetDeliveryTime).format('h:mm A');
    var estimatedDeliveryTimeDescription = contentStrings.estimatedDeliveryTime() + " " + formattedDeliveryTime;
    // track the entry's size when it is mounted
    // to show the right size of CTA buttons when switching calendar views with showWeekends setting
    React.useEffect(function () {
        checkEntrySize(entryRef);
    }, []);
    var handleTrackOrder = function () {
        track(EmployeeCalendarEvents.TRACK_ORDER_CLICK, {
            team_account_id: isEmployeeView
                ? calendarInfo === null || calendarInfo === void 0 ? void 0 : calendarInfo.teamAccountId
                : teamAccountId,
            cart_id: entry.cart.id,
            store_id: entry.store.id,
            date_clicked: entryDate,
            is_admin: !isEmployeeView,
        });
        window.open(EXTERNAL_ROUTES.MARKETPLACE_TRACK_ORDER + "/" + entry.orderId, // link to order tracking page
        '_blank', 'noopener');
    };
    return (React.createElement(EntryContainer, { ref: entryRef },
        React.createElement(StoreImageView, { entry: entry },
            React.createElement(EntryTileButtonsWrapper, null,
                React.createElement(InlineChildren, { size: InlineChildren.Sizes.TagPaddingHorizontalMedium },
                    React.createElement(TrackOrderButton, { "data-testid": GroupOrderEntryTestId.TrackOrderButton, isMobile: isMobile, onClick: handleTrackOrder, children: contentStrings.trackOrderButton() })))),
        React.createElement(Inset, { verticalSize: InsetSize.XSmall, horizontalSize: InsetSize.None },
            React.createElement(Text, { styles: TextStyle.Label2Emphasis }, entry.store.name),
            React.createElement(EstimatedDeliveryTimeText, { children: estimatedDeliveryTimeDescription }),
            React.createElement(HiddenPlaceholderForEmptyText, null)),
        debugMode && React.createElement(Text, null, entry.targetDeliveryTime)));
};
export default EntryViewTrackOrder;
